var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldmale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.5 0C187.05 0 241 53.95 241 120.5C241 187.05 187.05 241 120.5 241C53.95 241 0 187.05 0 120.5C0 53.95 53.95 0 120.5 0Z",
    fill: "#F35B04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.522 158.399C102.522 158.399 100.764 175.691 95.2344 180.75C95.2344 180.75 126.759 193.912 148.196 181.236C148.196 181.236 139.392 170.103 140.907 154.998L102.522 158.399Z",
    fill: "#FFE1D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6077 177.835L52.9627 186.095C52.9627 186.095 44.9657 193.302 35.4707 203.101C35.4707 203.101 60.8387 237.032 119.043 239.542C119.043 239.542 164.009 243.834 207.475 203.101C207.475 203.101 194.46 189.782 189.983 186.095L152.57 179.778L143.338 178.806C143.338 178.806 132.919 187.332 125.846 188.038C120.981 188.524 115.156 188.038 115.156 188.038L98.6357 185.123L99.6077 177.835Z",
    fill: "#B6CAD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6621 185.123L146.737 183.665L123.9 239.542L117.584 240.028L102.035 212.333L97.6621 185.123Z",
    fill: "#B8E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1484 180.264C98.1484 180.264 131.779 190.267 143.822 177.835L140.906 188.038C140.906 188.038 124.329 196.26 100.092 187.552L98.1484 180.264Z",
    fill: "#F6F6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.822 172.976C143.822 172.976 168.22 185.571 163.743 204.073L145.765 196.298L147.223 213.79L123.9 240.028C123.9 240.028 140.906 197.918 143.822 172.976Z",
    fill: "#53B8F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6345 172.976C98.6345 172.976 75.9025 185.733 78.2275 204.558L96.2055 197.27L94.7475 214.276L118.555 240.514C118.555 240.514 102.035 195.003 98.6345 172.976Z",
    fill: "#53B8F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3744 37.4131C90.3744 37.4131 123.964 21.1791 154.025 37.4131C154.025 37.4131 159.788 45.7831 162.285 55.8771C165.522 68.9571 165.687 84.5441 165.687 84.5441V110.782L151.596 132.161L134.59 133.619C134.59 133.619 114.489 126.616 112.239 127.788C109.988 128.96 101.064 135.562 101.064 135.562C101.064 135.562 91.8964 141.436 89.4024 137.02C86.9094 132.605 82.9074 127.831 81.6284 123.415C80.3494 119 75.3764 105.48 75.3114 103.008C75.2474 100.536 76.2834 79.6851 76.2834 79.6851L79.6844 51.5041L90.3744 37.4131Z",
    fill: "#FFE1D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2641 93.857C75.2641 93.857 75.1591 93.277 75.0101 92.223C74.1491 86.117 71.8181 64.089 79.8691 46.536C80.5271 45 86.8751 24.1 121.313 25.027C123.944 25.027 163.185 22.871 167.362 57.291C167.362 57.291 171.079 68.041 167.362 93.857H160.455V65.895C160.455 65.895 155.62 52.677 144.338 59.442C144.338 59.442 129.306 79.41 95.9861 57.291C95.9861 57.291 80.6251 55.442 82.1711 74.499V96.008",
    fill: "#0D0B0B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2107 75.7981C73.5647 75.7981 76.2837 78.5181 76.2837 81.8721V105.195C76.2837 108.549 73.5647 111.268 70.2107 111.268C66.8557 111.268 64.1367 108.549 64.1367 105.195V81.8721C64.1367 78.5181 66.8557 75.7981 70.2107 75.7981Z",
    fill: "#FFE1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.76 75.7981C175.114 75.7981 177.835 78.5181 177.835 81.8721V105.195C177.835 108.549 175.114 111.268 171.76 111.268C168.406 111.268 165.688 108.549 165.688 105.195V81.8721C165.688 78.5181 168.406 75.7981 171.76 75.7981Z",
    fill: "#FFE1D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8618 36.442C90.8618 36.442 72.0978 32.84 72.8838 75.798C72.8838 75.798 78.8998 88.231 72.8838 111.268C72.8838 111.268 70.6398 150.182 100.58 162.286C100.58 162.286 130.161 172.411 150.14 157.427C150.14 157.427 170.247 143.379 169.576 110.782C169.576 110.782 164.659 95.884 170.061 76.77C170.061 76.77 173.122 38.104 152.57 36.442C152.57 36.442 165.186 61.75 162.773 80.171C162.773 80.171 170.854 93.333 162.773 108.839C162.773 108.839 154.334 127.831 141.88 131.675C141.88 131.675 139.758 119.409 120.015 119.042C120.015 119.042 104.936 121.191 100.58 132.161C100.58 132.161 86.1478 129.37 78.2288 102.522C78.2288 102.522 74.4868 92.442 79.2008 83.087C79.8478 82.439 78.7148 53.367 90.8618 36.442Z",
    fill: "#0D0B0B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.202 132.647C129.581 132.647 135.564 135.149 135.564 138.235C135.564 141.321 129.581 143.823 122.202 143.823C114.822 143.823 108.84 141.321 108.84 138.235C108.84 135.149 114.822 132.647 122.202 132.647Z",
    fill: "#FFE1D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldmale);
export default __webpack_public_path__ + "static/media/oldmale.596eadaca1f98a65179e62650e093170.svg";
export { ForwardRef as ReactComponent };